import { HttpClient } from './http-client';

export abstract class PlatformAPIHttpClient extends HttpClient {
    public constructor() {
        super('https://ads-api.imasters.com.br/api/v1');
    }
}